var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#585858",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3077 10H11.6923C10.7577 10 10 10.7577 10 11.6923V19.3077C10 20.2423 10.7577 21 11.6923 21H19.3077C20.2423 21 21 20.2423 21 19.3077V11.6923C21 10.7577 20.2423 10 19.3077 10Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#585858",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53846 14H4.69231C4.24348 14 3.81303 13.8217 3.49567 13.5043C3.1783 13.187 3 12.7565 3 12.3077V4.69231C3 4.24348 3.1783 3.81303 3.49567 3.49567C3.81303 3.1783 4.24348 3 4.69231 3H12.3077C12.7565 3 13.187 3.1783 13.5043 3.49567C13.8217 3.81303 14 4.24348 14 4.69231V5.53846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGray);
export default __webpack_public_path__ + "static/media/copy--gray.3cec830a42a0bcdd4ee72bb1504726ee.svg";
export { ForwardRef as ReactComponent };